import React from 'react'
import { createRoot } from 'react-dom/client';
import './styles/globals.css'
import Shell from './Shell.jsx'
import ErrorLayout from './error_layout.jsx'

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {errorOccurred: false, errorInfo: ""};
    }

    static getDerivedStateFromError(error) {
        return {errorOccurred: true, errorInfo: error.message + "\n" + error.stack};
    }

    render() {
        const {errorOccurred, errorInfo} = this.state;
        if (errorOccurred) {
            return (
                <ErrorLayout errorInfo={errorInfo}/>
            )
        } else {
            return (
                <Shell/>
            );
        }

    }
}

createRoot(document.getElementById('app')).render(<App/>);
